import { render } from "./socialLinks-component.vue?vue&type=template&id=557bfb24&scoped=true"
import script from "./socialLinks-component.vue?vue&type=script&lang=js"
export * from "./socialLinks-component.vue?vue&type=script&lang=js"

import "./socialLinks-component.vue?vue&type=style&index=0&id=557bfb24&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557bfb24"]])

export default __exports__